import { render } from "./BlockOverlay.vue?vue&type=template&id=36603fa4&scoped=true"
import script from "./BlockOverlay.vue?vue&type=script&lang=js"
export * from "./BlockOverlay.vue?vue&type=script&lang=js"

import "./BlockOverlay.vue?vue&type=style&index=0&id=36603fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36603fa4"]])

export default __exports__